import ShowHero from './ShowHero';

export default ShowHero;
